<template>
  <tr>
    <td>{{ diaryDate }}</td>
    <td>{{ dyspneaAtRest }}</td>
    <td>{{ dyspneaOnExertion }}</td>
    <td>{{ heartpain }}</td>
    <td>{{ chestpain }}</td>
    <td>{{ weight }}</td>
    <td>{{ comment }}</td>
  </tr>
</template>

<script>
import { formatDate } from '@/mixins/format-date.js'
import declension from '@/modules/declension'

export default {
  name: 'DiaryTableRow',
  components: {},
  mixins: [formatDate],
  props: {
    diaryData: {
      type: Object,
      required: false
    }
  },
  computed: {
    diaryDate() {
      return (
        this.getFormattedDate(this.diaryData.createdAt, true) +
        ' ' +
        this.getFormattedTime(this.diaryData.createdAt)
      )
    },
    dyspneaAtRest() {
      return `${this.diaryData.content.breath_shortness_at_rest_intensity || 0} - ${this.getIntensiveName(
        this.diaryData.content.breath_shortness_at_rest_intensity
      )}`
    },
    dyspneaOnExertion() {
      return `${this.diaryData.content.breath_shortness_on_exertion_intensity || 0} - ${this.getIntensiveName(
        this.diaryData.content.breath_shortness_on_exertion_intensity
      )}`
    },
    heartpain() {
      return `${this.diaryData.content.heart_pain_attacks_number || 0} ${declension(
        this.diaryData.content.heart_pain_attacks_number,
        [
          this.$tc('courseReport.attack', 0),
          this.$tc('courseReport.attack', 1),
          this.$tc('courseReport.attack', 2)
        ]
      )}`
    },
    chestpain() {
      return `${this.diaryData.content.pain_behind_chest_intensity || 0} - ${this.getIntensiveName(
        this.diaryData.content.pain_behind_chest_intensity
      )}`
    },
    weight() {
      return `${this.diaryData.content.body_weigth} ${this.$t('unit.kg')}` || '-'
    },
    comment() {
      return this.diaryData.content.comment
    }
  },
  methods: {
    getIntensiveName(score) {
      if (score >= 1 && score <= 3) {
        return this.$tc('courseReport.mild', 1)
      } else if (score >= 4 && score <= 6) {
        return this.$tc('courseReport.moderate', 1)
      } else if (score === 7 || score === 8) {
        return this.$tc('courseReport.severe', 1)
      } else if (score === 9 || score === 10) {
        return this.$tc('courseReport.extreme', 1)
      } else {
        return this.$tc('courseReport.notbothered', 1)
      }
    }
  }
}
</script>
